function t(r){return r instanceof Error}export{t as a};
